import MagnifyingGlassDocumentIcon from './MagnifyingGlassDocumentIcon'

export default MagnifyingGlassDocumentIcon
